export default {
  getAlerts: (state) => state.alerts,
};
